import { MantineThemeOverride } from '@mantine/core';

export type GridTheme = NonNullable<MantineThemeOverride['components']>['Grid'];

export const Grid: GridTheme = {
  // todo: define
};
